import useHandleFingerPay from '@hooks/order/useHandleFingerPay';
import useRegisterFingerPay from '@hooks/order/useRegisterFingerPay';
import useScript from '@hooks/useScript';
import { PaymentMethod } from '@models/order';

const scriptUrl = import.meta.env.VITE_FINGER_PAY_SCRIPT_URL;

interface Props {
    orderNo: string;
    mallId: string;
    requestedAt: string;
    hashString: string;
    itemName: string;
    paymentAmount: number;
    returnUri: string;
    paymentMethod: PaymentMethod;
}

function useExecuteFingerPay(props: Props) {
    useRegisterFingerPay();
    const handleFingerPay = useHandleFingerPay();
    const onLoad = () => {
        handleFingerPay(props);
    };

    useScript({ src: scriptUrl, onLoad });
}

export default useExecuteFingerPay;
